import { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify';
import { getDailySales, DailySalesResponse } from '../services/DashboardCRUD';

export default function DailySalesChart() {
  const intl = useIntl();
  const [salesData, setSalesData] = useState<DailySalesResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDailySales();
  }, []);

  async function fetchDailySales() {
    try {
      setLoading(true);
      const { data } = await getDailySales();
      setSalesData(data);
    } catch (error) {
      toast.error(intl.formatMessage({ id: 'dailySales.errorFetchingData' }));
      console.warn(error);
    } finally {
      setLoading(false);
    }
  }

  const chartData = {
    labels: [
      `${intl.formatMessage({ id: 'dailySales.plansWithTrial' })} (${salesData?.trials || 0})`,
      `${intl.formatMessage({ id: 'dailySales.plansWithoutTrial' })} (${salesData?.no_trials || 0})`,
    ],
    datasets: [
      {
        label: intl.formatMessage({ id: 'dailySales.quantity' }),
        data: [salesData?.trials || 0, salesData?.no_trials || 0],
        backgroundColor: ['rgba(54, 162, 235, 0.8)', 'rgba(99, 255, 182, 0.8)'],
        borderColor: ['rgba(54, 162, 235, 1)', 'rgba(99, 255, 182, 1)'],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
  };

  return (
    <>
      <h1 className="mb-8">{intl.formatMessage({ id: 'dailySales.title' })}</h1>
      <div className="card">
        <div className="card-body">
          <div style={{ height: '400px' }}>
            {loading && (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: '100%' }}
              >
                <span className="spinner-border text-primary"></span>
              </div>
            )}
            {!loading && salesData && (
              <Bar data={chartData} options={chartOptions} />
            )}
            {!loading && !salesData && (
              <p className="text-center">
                {intl.formatMessage({ id: 'businessDashboard.noData' })}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
